import { render } from "./SideMenu.vue?vue&type=template&id=4bc8bedc&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=4bc8bedc&scoped=true&lang=css"

import exportComponent from "/home/apps/bugaplus/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc8bedc"]])

export default __exports__